import React from 'react';

import Root from './modules/Root.screen';
import { Provider } from 'react-redux';

import configure from './modules/store';

import './App.scss';

const store = configure();

function App() {
  return (
    <Provider store={store}>
      <Root />
    </Provider>
  );
}

export default App;
